import Control from "sap/ui/core/Control";
import { BaseLogFormatter } from "./BaseLogFormatter";
import {
  FormatDate,
  FormatDateTime,
  FormatPrice,
} from "akademika/akamont/utils/FormatUtil";
import ObjectStatus from "sap/m/ObjectStatus";
import { GetStateForWorkOrderStatus } from "akademika/akamont/utils/WorkOrderStatusUtil";

export class WorkOrderLogFormatter extends BaseLogFormatter {
  generateControlForValue(
    value: string | null | undefined,
    fieldName: string
  ): Control {
    switch (fieldName) {
      case "ServiceMeasurementUnit": {
        return this.getTextForServiceMeasurementUnit(value);
      }
      case "ServiceQuantityPlanned":
      case "ServiceQuantityPerformed":
      case "ServiceQuantityCorrected":
        return this.generateTextControl(value);
      case "IsUncompleted":
      case "IsCorrected":
      case "IsDisputed": {
        const translatedValue = this.getTextForBooleanValue(value);
        return this.generateTextControl(translatedValue);
      }
      case "CreationDate":
        return this.generateTextControl(FormatDateTime(value));
      case "PlannedDate":
        return this.generateTextControl(FormatDate(value));
      case "Status":
        if (!value) return this.generateTextControl();
        return new ObjectStatus({
          state: GetStateForWorkOrderStatus(value),
          text: this._controller.translate(value),
          inverted: true,
        });
      case "Category":
        return this.generateTextControl(this._controller.translate(value));
      case "ContractPrice":
        return this.generateTextControl(FormatPrice(value));
      case "ContractDistance":
        return this.generateTextControl(value && value + " km");
      default:
        return this.generateTextControl(value);
    }
  }
}
